module.exports = __webpack_public_path__ + "static/img/财务.0cdfc856.png";